/**
 * @file
 *
 * This file describes only the 'Action Types' and his 'Actions Creators'
 * https://redux.js.org/docs/basics/Actions.html
 * @author JPablo
 */

/*
* Action Types
*/
import {Oficina} from "../../dominio/general/modelo/Oficina";

export const CONSULTAR_MENU = "CONSULTAR_MENU";
export const MENU_CONSULTADO = "MENU_CONSULTADO";
export const ERROR_CONSULTANDO_MENU = "ERROR_CONSULTANDO_MENU";
export const ERROR_AUTORIZACION = "ERROR_AUTORIZACION";
export const CERRAR_MENU = "CERRAR_MENU";
export const ABRIR_MENU = "ABRIR_MENU";

export const CONSULTAR_OFICINAS = "CONSULTAR_OFICINAS";
export const OFICINAS_CONSULTADAS = "OFICINAS_CONSULTADAS";
export const ERROR_CONSULTANDO_OFICINAS = "ERROR_CONSULTANDO_OFICINAS";

/*
* Actions Creators
* Note that's a good practice type the Action fields {..., name: name} instead of {..., name}
*/
export const consultarMenu = () => ({type: CONSULTAR_MENU});
export const menuConsultado = (menu: Array<any>, dniLogin: String, lastAccess: String, logoutURL: String, fullName: string, isSuper: boolean) => ({
    type: MENU_CONSULTADO,
    menu: menu,
    dniLogin,
    lastAccess,
    logoutURL,
    fullName,
    isSuper
});
export const errorConsultandoMenu = () => ({type: ERROR_CONSULTANDO_MENU});
export const errorAutorizacion = (respuesta: String, codigo: String) => ({
    type: ERROR_AUTORIZACION,
    respuesta: respuesta,
    codigo: codigo
});

export const consultarOficinas = () => ({type: CONSULTAR_OFICINAS});
export const oficinasConsultadas = (oficinas: Array<Oficina>) => ({type: OFICINAS_CONSULTADAS, oficinas});
export const errorConsultandoOficinas = () => ({type: ERROR_CONSULTANDO_OFICINAS});

export const cerrarMenu = () => ({type: CERRAR_MENU});
export const abrirMenu = () => ({type: ABRIR_MENU});


// WEBPACK FOOTER //
// ./src/co/sura/inicio/modulos/inicioActions.ts